import { AbstractControl, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(minDate: Date, maxDate: Date): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const date = new Date(control.value);
    date.setHours(0, 0, 0, 0);
    if (
      !!control.value &&
      ((minDate && date < minDate) || (maxDate && date > maxDate))
    ) {
      return { dateRange: { value: control.value } };
    }
    return null;
  };
}
